// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setEnrollmentReportList,
  setEnrollmentReportPredefinedFilter,
  resetEnrollmentReport
} from 'src/store/modules/reports/enrollmentReport'

const initialState = {
  enrollmentReportList: [],
  enrollmentPredefinedFilter: {}
}

export default handleActions(
  {
    [setEnrollmentReportList](state, { payload: enrollmentReportList }) {
      return {
        ...state,
        enrollmentReportList
      }
    },

    [setEnrollmentReportPredefinedFilter](
      state,
      { payload: enrollmentPredefinedFilter }
    ) {
      return {
        ...state,
        enrollmentPredefinedFilter
      }
    },

    [resetEnrollmentReport]() {
      return initialState
    }
  },
  initialState
)
